import React from 'react';
import fr from 'facet-rest';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Sidebar from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar'; // TODO: Move this outside of what if
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';

const useStyles = buildUseStyles('SidebarContent', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    flex: 1,
  },
  sidebar: {
    position: 'sticky',
    top: theme.heights.advisorNavigationHeight,
  },
}));

const SidebarContent = () => {
  const classes = useStyles();
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  const handleTabChange = tabKey => {
    const [activeTabResource] = pageContentResource.attr('sidebarTabs').resources().list().filter((tabResource) => {
      return tabResource.attr('key') === tabKey;
    });
    loadPageContentLink(activeTabResource?.relationship(fr.relationships.tabData.name).link('related'));
  };

  return (
    <Box className={classes.root}>
      <Sidebar
        className={classes.sidebar}
        onChange={handleTabChange}
      />
    </Box>
  );
};

export default SidebarContent;
